import { motion, AnimatePresence } from "framer-motion";
import { PhoneOff, Video } from "lucide-react";

// Appel vidéo via Jitsi Meet (iframe publique meet.jit.si — gratuit, sans clé)
export const VideoCallModal = ({ salle, displayName, autreNom, onClose }) => {
  const url =
    `https://meet.jit.si/${salle}` +
    `#config.prejoinPageEnabled=false` +
    `&config.startWithVideoMuted=false` +
    `&userInfo.displayName=${encodeURIComponent(`"${displayName}"`)}`;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[90] bg-black/85 backdrop-blur-sm flex items-center justify-center p-3 sm:p-6"
        data-testid="video-call-overlay"
      >
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.97 }}
          transition={{ duration: 0.3 }}
          className="bg-[#12100E] rounded-3xl w-full max-w-4xl overflow-hidden shadow-2xl flex flex-col"
          data-testid="video-call-modal"
        >
          <div className="flex items-center justify-between gap-3 px-5 py-3.5">
            <div className="flex items-center gap-2.5 min-w-0">
              <Video size={17} className="text-[#E05638] shrink-0" />
              <span className="font-heading font-bold text-stone-100 text-sm truncate">
                Appel vidéo avec {autreNom}
              </span>
            </div>
            <button
              onClick={onClose}
              data-testid="video-call-hangup"
              className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold px-5 py-2 rounded-full transition-colors shrink-0"
            >
              <PhoneOff size={15} /> Raccrocher
            </button>
          </div>
          <iframe
            title="Appel vidéo FodindinCa"
            src={url}
            allow="camera; microphone; fullscreen; display-capture; autoplay"
            className="w-full h-[65vh] border-0 bg-black"
            data-testid="video-call-iframe"
          />
          <p className="text-[11px] text-stone-500 text-center py-2 px-4">
            Appel sécurisé via Jitsi Meet — la salle est privée et liée à votre conversation. Raccrochez pour revenir à la discussion.
          </p>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
